import * as z from "zod";
import {
  MAX_SHIPPING_METHOD_IDENTITIES,
  shippingMethodIdentitySchema,
} from "./shipping-method-family";
import { splitShipmentLocationGroupSchema } from "./split-shipment-location-groups";

export enum SplitShipmentMethodField {
  TITLE = "TITLE",
}

export enum SplitShipmentMethodOperator {
  IS = "IS",
}

export const splitShipmentDiscountSchema = z.object({
  version: z.literal(1),
  enabled: z.boolean(),
  percentage: z.number().int().min(1).max(100),
  locationGroups: z.array(splitShipmentLocationGroupSchema).max(10),
  rmrMethods: z
    .array(shippingMethodIdentitySchema)
    .max(MAX_SHIPPING_METHOD_IDENTITIES),
});
export type SplitShipmentDiscount = z.infer<typeof splitShipmentDiscountSchema>;

export const defaultSplitShipmentDiscount: SplitShipmentDiscount = {
  version: 1,
  enabled: false,
  percentage: 100,
  rmrMethods: [],
  locationGroups: [],
};
